"use client";

import type { PackageSummary } from "../pricing";
import { ManageYesNoStep } from "./ManageYesNoStep";

/**
 * Accounting side: outstanding employer's returns and management accounts for
 * past years. The counterpart to ManagePastReturnsStep, which asks the same
 * question about the company-secretary work — no explainer panel on this one.
 */
export function ManagePayrollReturnsStep({
  value,
  onChange,
  summary,
  onNext,
}: {
  value: string | null;
  onChange: (value: string) => void;
  summary: PackageSummary;
  onNext: () => void;
}) {
  return (
    <ManageYesNoStep
      heading="Need help with employer’s returns and management account reports from previous years?"
      intro="As your new accountant, we can assist with filing outstanding employer’s returns to ensure compliance and update your management accounts."
      name="past-payroll-returns"
      value={value}
      onChange={onChange}
      summary={summary}
      onNext={onNext}
    />
  );
}
